<template>
  <v-container fluid>
    <div class="modal-padding cp3-modal fix-error-message">
      <v-row>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Edit Coordinator:</div>
            <div class="field-data">
              <v-text-field
                v-model="name"
                class="fix-200"
              ></v-text-field>
              <InputError :data="error.name" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Email ID:</div>
            <div class="field-data">
              <v-text-field
                v-model="email"
                class="fix-200"
              ></v-text-field>
              <InputError :data="error.email" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">
              Select Center:
            </div>
            <div class="field-data">
              <multi-select
                :items="centers"
                :showCoorCenter="true"
                ref="centerSelect"
                :onChange="onCenterchange"
                label="Center"
                hide-details
                dense
                outlined
                class="fix-200"
                filled
                noText="No Center"
                :isShowNo="canAddNoCenter()"
              ></multi-select>
              <InputError :data="error.center" />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="bottom-btn">
            <v-btn
              :loading="approvalLoading"
              @click="onSaveOrApprove(1)"
              class="right-btn cust-btn"
              color="primary"
              >Approve</v-btn
            >
            <v-btn
              :loading="saveLoading"
              @click="onSaveOrApprove(0)"
              class="right-btn cust-btn"
              color="primary"
              >Save & return</v-btn
            >
            <v-btn
              @click="onClose({ status: false })"
              class="right-btn cust-btn"
              color="primary"
              >Cancel</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "EditStudentBatchDetails",
  props: ["onClose", "data", "status"],
  data() {
    return {
      name: this.data ? this.data.name : "",
      email: this.data ? this.data.email : "",
      approvalLoading: false,
      saveLoading: false,
      centers: [],
      selectedCenterId: [],
      coordinatorCenters: [],
      userCenters: this.data.center_data ? this.data.center_data : [],

      error: {
        name: {
          type: null,
          message: "Please enter name",
        },
        email: {
          type: null,
          message: "Please enter email",
        },
        center: {
          type: null,
          message: null,
        },
      },
    };
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      updateExternalUser: "userStore/updateExternalUser",
    }),
    validate() {
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.center.type = [];
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      }
      if (!this.selectedCenterId.length > 0) {
        this.error.center.type = "error";
        this.error.center.message = "Please select Center.";
        isValid = false;
      }
      if (!this.email || this.email.length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.error.email.type = "error";
        this.error.email.message =
          "Please enter a valid email ID.";
        isValid = false;
      }
      return isValid;
    },
    requestGetCenters() {
      this.centers = [];
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response.map((x, i) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
          
           
            if (this.userCenters && this.userCenters.length) {
             
              c.checked = this.userCenters.find(test => test.center_id == x.id ) != undefined|| false;
          
            }
    
            if (this.userCenters && this.userCenters.length) {
             
              c.disabled = this.userCenters.find(test => test.center_id == x.id && test.is_editable == 0) != undefined|| false;
            
            }
            if(this.coordinatorCenters && this.coordinatorCenters.length) {
              c.disabled = this.coordinatorCenters.find(test => test.value == x.id) == undefined || false
            }
            return c;

            
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetCentersByUser() {
      this.coordinatorCenters = [];
      this.$root.showLoader = true;
      this.getCentersByUser()
        .then((response) => {
          this.$root.showLoader = false;
          this.coordinatorCenters = response.map((x, i) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
            
          });
          this.requestGetCenters();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
 
 
  
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
    },
    onSaveOrApprove(requireApproval) {
      this.loading = true;
      if (this.validate()) {
        this.approvalLoading = requireApproval;
        this.saveLoading = !requireApproval;
        this.updateExternalUser({
          user_id: this.data.id,
          name: this.name.trim(),
          email: this.email,
          role_id: this.roleIds.CO,
          center_id: this.selectedCenterId,
          is_approved: requireApproval || undefined,
          status: 1,
        })
          .then((response) => {
            this.approvalLoading = false;
            this.saveLoading = false;
            this.loading = false;
            this.email = "";
            this.name = "";
            this.selectedCenterId = [];
            if (requireApproval === 1) {
              this.$toasted.success(`Approval status changed successfully`, {
                icon: "check_circle",
              });
            } else {
              this.$toasted.success(
                `Coordinator Details Updated successfully`,
                { icon: "check_circle" }
              );
            }
            this.saveLoading = false;

            this.loading = false;

            this.onClose({ status: false, reload: true });
          })
          .catch((err) => {
            this.loading = false;
            this.approvalLoading = false;
            this.saveLoading = false;
          });
      } else {
        this.loading = false;
      }
    },
    canAddNoCenter() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return user && user.role_id === constants.ROLES_ID.CO;
    },
  },

  mounted() {
    this.requestGetCentersByUser();
    this.selectedCenterId = this.userCenters.map((u) => u.center_id)
    //this.requestGetCenters();
  },
  watch: {
    status(val) {
      this.requestGetCentersByUser();
      this.userCenters = this.data.center_data ? this.data.center_data : [];
      this.selectedCenterId = this.userCenters.map((u) => u.center_id)
      this.name = this.data ? this.data.name : null;
      this.email = this.data ? this.data.email : null;
      //this.requestGetCenters();
    },
    selectedCenterId(val) {
      this.error.center.type = null;
    },
    name() {
      this.error.name.type = null;
    },
    email() {
      this.error.email.type = null;
    },
  },
};
</script>
